import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import {
  FormControlProps,
  FormCheckProps,
  FormSelectProps,
} from '@dreamai/types';

// Define custom interfaces for our simplified components
interface CustomFormControlProps {
  id?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  type?: string;
}

interface CustomFormCheckProps {
  id?: string;
  label?: string;
  checked?: boolean;
}

interface CustomFormSelectProps {
  id?: string;
  label?: string;
  value?: string;
  options?: Array<{ value: string; label: string }>;
}

// Simplified Form Control Component
export const FormControlComponent: React.FC<CustomFormControlProps> = (
  props,
) => {
  const { id, type, placeholder, label, value } = props;

  return (
    <Form.Group className='mb-3' controlId={id}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control
        type={type || 'text'}
        placeholder={placeholder}
        defaultValue={value}
      />
    </Form.Group>
  );
};

// Simplified Form Check Component
export const FormCheckComponent: React.FC<CustomFormCheckProps> = (props) => {
  const { id, label, checked } = props;
  const [isChecked, setIsChecked] = useState(checked || false);

  return (
    <Form.Group className='mb-3' controlId={id}>
      <Form.Check
        type='checkbox'
        label={label}
        checked={isChecked}
        onChange={(e) => setIsChecked(e.target.checked)}
      />
    </Form.Group>
  );
};

// Simplified Form Select Component
export const FormSelectComponent: React.FC<CustomFormSelectProps> = (props) => {
  const { id, label, options, value } = props;
  const [selectedValue, setSelectedValue] = useState(value || '');

  return (
    <Form.Group className='mb-3' controlId={id}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Select
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
      >
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};
